export enum UserType {
  New = 0,
  Chevron = 1,
  External = 2,
  Shared = 3,
}
